import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

interface ClientesListState {
  page: number;
  pageSize: number;
  search: string;
  estado?: number;
  tipo?: number;
  setPage: (page: number) => void;
  setPageSize: (pageSize: number) => void;
  setSearch: (search: string) => void;
  setEstado: (estado?: number) => void;
  setTipo: (tipo?: number) => void;
  reset: () => void;
}

const INITIAL_PAGE = 1;
const DEFAULT_PAGE_SIZE = 10;

/**
 * List position persisted in sessionStorage so "Volver" from the detail page
 * restores the exact page/filters the user left (clientes 360 navigation).
 * Rehydration is synchronous for sessionStorage, so reads at mount are safe.
 */
export const useClientesListStore = create<ClientesListState>()(
  persist(
    (set) => ({
      page: INITIAL_PAGE,
      pageSize: DEFAULT_PAGE_SIZE,
      search: '',
      estado: undefined,
      tipo: undefined,
      setPage: (page) => set({ page }),
      setPageSize: (pageSize) => set({ pageSize, page: INITIAL_PAGE }),
      setSearch: (search) => set({ search, page: INITIAL_PAGE }),
      setEstado: (estado) => set({ estado, page: INITIAL_PAGE }),
      setTipo: (tipo) => set({ tipo, page: INITIAL_PAGE }),
      reset: () =>
        set({
          page: INITIAL_PAGE,
          pageSize: DEFAULT_PAGE_SIZE,
          search: '',
          estado: undefined,
          tipo: undefined,
        }),
    }),
    {
      name: 'clientes-list',
      storage: createJSONStorage(() => sessionStorage),
    },
  ),
);
